import {
  ADD_BUSINESSCATEGORY_FAILED,
  ADD_BUSINESSCATEGORY_LOADING,
  ADD_BUSINESSCATEGORY_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  status: null,
};

export const addBusinessCategoryReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
  switch (action.type) {
    case ADD_BUSINESSCATEGORY_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case ADD_BUSINESSCATEGORY_SUCCESS:
      return {
      
        loading: false,
        BusCatMesg: action.payload,
        status: action.status,
        error: null,
      };
    case ADD_BUSINESSCATEGORY_FAILED:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: action.error,
      };
      default:
        return state;
  }
};
